import { api } from "shared/config/api/api";
import { DEFAULT_PER_PAGE, getNextPage } from "shared/utils";
import { TICKETS_LIST_TAG, ticketTag } from "../model/tags";
import type {
  SupportTicketDetail,
  SupportTicketsFilter,
  SupportTicketsPage,
} from "../model/types";

export const supportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSupportTickets: builder.infiniteQuery<
      SupportTicketsPage,
      SupportTicketsFilter,
      number
    >({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage) => getNextPage(lastPage),
      },
      query: ({ queryArg, pageParam }) => ({
        url: "/support/tickets",
        params: { ...queryArg, page: pageParam, per_page: DEFAULT_PER_PAGE },
      }),
      providesTags: [TICKETS_LIST_TAG],
    }),
    getSupportTicket: builder.query<SupportTicketDetail, number>({
      query: (ticketId) => `/support/tickets/${ticketId}`,
      providesTags: (_result, _error, ticketId) => [ticketTag(ticketId)],
    }),
  }),
});

export const { useGetSupportTicketsInfiniteQuery, useGetSupportTicketQuery } =
  supportApi;
